import { AssertionPresetSetupProps } from "./AssertionPresetSetupBase";
import GroundTruthPresetSetup from "./GroundTruthPresetSetup";
import StructuralPresetSetup from "./StructuralPresetSetup";

import { EvaluationPresetType } from "@/queries/smart-tables";

type AssertionPresetType = Extract<EvaluationPresetType, "GROUND_TRUTH_COMPARE" | "STRUCTURAL">;

interface AssertionPresetSetupRouterProps extends AssertionPresetSetupProps {
  presetType: AssertionPresetType;
}

const AssertionPresetSetup = ({ presetType, ...props }: AssertionPresetSetupRouterProps) => {
  if (presetType === "GROUND_TRUTH_COMPARE") {
    return <GroundTruthPresetSetup {...props} />;
  }

  return <StructuralPresetSetup {...props} />;
};

export default AssertionPresetSetup;
